import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FaBookOpen,
  FaCheckCircle,
  FaClock,
  FaGraduationCap,
  FaUsers,
} from "react-icons/fa";
import { getBusinessDashboard } from "../../store/actions/adminActions";
import AuthContext from "../../context/AuthProvider";
import { InviteModal } from "./InviteModal";
import {
  CardDivider,
  CardFooter,
  CardFooterDot,
  CardGlow,
  CardIconWrap,
  CardLabel,
  CardTopRow,
  CardValue,
  DashHeader,
  DashPage,
  DashSubtitle,
  DashTitle,
  StatCard,
  StatCardWrap,
  StatsGrid,
} from "./DashboardStyles";

const STATS = (s = {}) => [
  {
    key: "subscribers",
    value: s.total_number_of_subscribed_users,
    label: "Subscribed Learners",
    sub: "Total enrolled users",
    icon: <FaUsers size={20} />,
    color: "#2f67d8",
  },
  {
    key: "practised",
    value: s.total_number_of_questions_practised,
    label: "Exams Practised",
    sub: "Total exam attempts",
    icon: <FaBookOpen size={18} />,
    color: "#7c3aed",
  },
  {
    key: "completed",
    value: s.total_number_of_questions_finished,
    label: "Exams Completed",
    sub: "Fully finished sessions",
    icon: <FaCheckCircle size={18} />,
    color: "#059669",
  },
  {
    key: "users_practised",
    value: s.total_number_of_users_practised,
    label: "Users Practised",
    sub: "Unique active learners",
    icon: <FaGraduationCap size={20} />,
    color: "#0891b2",
  },
  {
    key: "yet_practised",
    value: s.total_number_of_users_yet_practised,
    label: "Yet to Practice",
    sub: "Awaiting first attempt",
    icon: <FaClock size={18} />,
    color: "#d97706",
  },
];

export const BusinessDashboard = ({ handle }) => {
  const dispatch = useDispatch();
  const { user } = useContext(AuthContext);
  const { businessdata } = useSelector((state) => state.admin);
  const businessId =
    user?.businessAccess?.businessId ||
    user?.businessAccess?.channelId ||
    user?.managedBusinessId;

  useEffect(() => {
    dispatch(getBusinessDashboard(businessId ? { businessId } : {}));
  }, [businessId, dispatch]);

  const stats = STATS(businessdata.stats || {});

  return (
    <>
      <DashPage className="col-md-10 offset-md-1">
        <DashHeader>
          <DashTitle>Current User Overview</DashTitle>
          <DashSubtitle>Live performance metrics for your learners</DashSubtitle>
        </DashHeader>

        <StatsGrid>
          {stats.map(({ key, value, label, sub, icon, color }, idx) => (
            <StatCardWrap key={key} $idx={idx}>
              <StatCard $color={color}>
                <CardGlow $color={color} />

                <CardTopRow>
                  <CardIconWrap $color={color}>{icon}</CardIconWrap>
                </CardTopRow>

                <CardValue $delay={idx * 80 + 200}>
                  {value ?? "—"}
                </CardValue>
                <CardLabel>{label}</CardLabel>

                <CardDivider />

                <CardFooter>
                  <CardFooterDot $color={color} />
                  {sub}
                </CardFooter>
              </StatCard>
            </StatCardWrap>
          ))}
        </StatsGrid>
      </DashPage>

      <InviteModal />
    </>
  );
};
